const $btn = $('.js-load-all-news');
const $foot = $('.js-load-all-foot');
const $list = $('.js-articles-items');

if ($btn.length && $foot.length && $list.length) {
	$btn.on('click', function (e) {
		e.preventDefault();

		const offset = $list.children().length;
		const ajaxUrl = (window.woonAjax && window.woonAjax.url) || '/wp-admin/admin-ajax.php';

		$btn.addClass('is-loading');

		$.post(ajaxUrl, {
			action: 'load_all_news',
			offset: offset,
		}, function (res) {
			if (res && res.success) {
				$list.append(res.data);
			}
			$foot.remove();
		}).fail(function () {
			$btn.removeClass('is-loading');
		});
	});
}
